/**
 * The stack trace shape expected by the backend error report and the
 * error boundaries: the error's own stack (or message as fallback)
 * followed by the optional React component stack.
 */
export const buildErrorStackTrace = (error: unknown, componentStack?: string | null): string =>
  [error instanceof Error ? (error.stack ?? error.message) : String(error), componentStack]
    .filter(Boolean)
    .join('\n');
